// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-form{padding:16px}.edit-form__filename{margin-top:16px;margin-bottom:16px}.edit-form .bx--list-box__menu{height:150px;max-height:150px;z-index:6000}.bx--dropdown-item{height:48px}.bx--dropdown-link{height:100%;display:flex;justify-content:center;flex-direction:column-reverse}", ""]);
// Exports
module.exports = exports;
